"use client"
import { useRouter } from "next/navigation";
import Conference from "./components/Conference/Conference";
import EventImage from "./components/EventImage/EventImage";
import Membership from "./components/Membership/Membership";
import SectionWrapper from "@/partials/sections/Section/SectionWrapper";
import FlexSection from "@/partials/sections/Section/FlexSection";
import GridSection from "@/partials/sections/Section/GridSection";

const ProfessionalEvents = ({conferenceData}) => {
  return (
    <SectionWrapper extraClass={"px-5 pt-16 pb-20 md:pb-32  "}>
      <GridSection extraClass={"md:grid-cols-3 grid-cols-1"}>
        <Conference />
        <EventImage data={conferenceData} />
        <Membership />
      </GridSection>
    </SectionWrapper>
  );
};

export default ProfessionalEvents;
